import { FC } from "react";
import { Choice } from "./CancellationOptions";

// The 24h hold on card money: it is what keeps "Rikonfirmo rezervimin" possible.
const PayoutTiming: FC<{ payoutNow: boolean; onChange: (next: boolean) => void }> = ({
  payoutNow,
  onChange
}) => (
  <Choice
    type="checkbox"
    label="Rimburso në kartelë menjëherë"
    tip="Rezervimi nuk mund të rikonfirmohet më."
    checked={payoutNow}
    onChange={() => onChange(!payoutNow)}
  />
);

export default PayoutTiming;
